import React from "react";

/* Resilience: if a mobile screen throws (e.g. a malformed payload from the
   backend), render an honest inline error with a retry instead of letting the
   whole React tree unmount to a blank screen. Resets when the route changes. */
export default class MobileErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidUpdate(prev) {
    if (prev.routeKey !== this.props.routeKey && this.state.error) this.setState({ error: null });
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ textAlign: "center", padding: "80px 24px", color: "#a1a1aa" }}>
          <p style={{ font: "800 18px 'Manrope'", color: "#fff", marginBottom: 8 }}>Something went wrong</p>
          <p style={{ font: "500 14px 'Outfit'" }}>This screen hit an error. Try again.</p>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            style={{ marginTop: 18, height: 44, padding: "0 18px", borderRadius: 14, border: 0, cursor: "pointer", background: "#18181C", boxShadow: "inset 0 0 0 1px #2F2F35", color: "#fff", font: "700 14px 'Outfit'" }}
          >
            Reload screen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
